module.exports = __webpack_public_path__ + "static/img/Minichmayr-Johannes.40e7756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/at/Minichmayr-Johannes.jpg
// module id = VVvX
// module chunks = 1